'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _CompanyProfileModal = require('./CompanyProfileModal.css');

var _CompanyProfileModal2 = _interopRequireDefault(_CompanyProfileModal);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _ = require('../');

var _reactModal = require('react-modal');

var _reactModal2 = _interopRequireDefault(_reactModal);

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CompanySectors = require('../../data/CompanySectors.json');
var CompanyLinks = require('../../data/CompanyLinks.json');
var CompanyProfiles = require('../../data/CompanyProfiles.json');

var CompanyProfileModal = (_dec = (0, _reactCssModules2.default)(_CompanyProfileModal2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(CompanyProfileModal, _Component);

  function CompanyProfileModal(props) {
    (0, _classCallCheck3.default)(this, CompanyProfileModal);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CompanyProfileModal.__proto__ || (0, _getPrototypeOf2.default)(CompanyProfileModal)).call(this, props));

    _this.openModal = function () {
      _this.setState({ modalOpen: true });
    };

    _this.closeModal = function () {
      _this.setState({ modalOpen: false });
    };

    _this.renderFlags = function (flags) {
      if (flags.length > 0) {
        return _react2.default.createElement(
          'div',
          { styleName: 'flag-box' },
          flags.map(function (flag) {
            var splitName = flag[2].split(' ');
            var shortname = splitName[0];
            shortname = shortname === 'Palm' ? 'Palm oil' : shortname;
            var type = splitName[splitName.length - 1];

            return _react2.default.createElement(
              'span',
              {
                styleName: 'flag ' + (type === 'producer' ? 'flag-p' : 'flag-c'),
                key: flag[0]
              },
              _react2.default.createElement('img', {
                styleName: 'detail-icon-holding',
                src: flag[1],
                alt: flag[2],
                title: flag[2]
              }),
              shortname
            );
          })
        );
      } else {
        return null;
      }
    };

    _this.state = {
      modalOpen: false
    };
    return _this;
  }

  (0, _createClass3.default)(CompanyProfileModal, [{
    key: 'render',
    value: function render() {
      var entry = CompanyProfiles.data[this.props.company_id];

      if (!entry) {
        return _react2.default.createElement(
          'span',
          null,
          this.props.children
        );
      }

      var shortName = entry[0];
      var profile = entry[1];

      var producersIcon = require('../../../static/images/icn-producers.svg');
      // const financiersIcon = require( '../../../static/images/icn-banks.svg' )
      var consumersIcon = require('../../../static/images/icn-consumers.svg');
      var iconPo = require('../../../static/images/icn-po.svg');
      var iconPp = require('../../../static/images/icn-pp.svg');
      var iconRb = require('../../../static/images/icn-rb.svg');
      var iconTb = require('../../../static/images/icn-tb.svg');
      var iconBf = require('../../../static/images/icn-bf.svg');
      var iconSy = require('../../../static/images/icn-sy.svg');
      var iconPoY = require('../../../static/images/icn-po-y.svg');
      var iconPpY = require('../../../static/images/icn-pp-y.svg');
      var iconRbY = require('../../../static/images/icn-rb-y.svg');
      var iconTbY = require('../../../static/images/icn-tb-y.svg');
      var iconBfY = require('../../../static/images/icn-bf-y.svg');
      var iconSyY = require('../../../static/images/icn-sy-y.svg');

      var pflags = [];
      var cflags = [];
      var c = CompanySectors.data[this.props.company_id];
      if ((0, _lodash.includes)(c, 'is_po_p')) {
        pflags.push(['is_po_p', iconPo, 'Palm oil producer']);
      }
      if ((0, _lodash.includes)(c, 'is_pp_p')) {
        pflags.push(['is_pp_p', iconPp, 'Paper/pulp producer']);
      }
      if ((0, _lodash.includes)(c, 'is_rb_p')) {
        pflags.push(['is_rb_p', iconRb, 'Rubber producer']);
      }
      if ((0, _lodash.includes)(c, 'is_tb_p')) {
        pflags.push(['is_tb_p', iconTb, 'Timber producer']);
      }
      if ((0, _lodash.includes)(c, 'is_bf_p')) {
        pflags.push(['is_bf_p', iconBf, 'Cattle producer']);
      }
      if ((0, _lodash.includes)(c, 'is_sy_p')) {
        pflags.push(['is_sy_p', iconSy, 'Soy producer']);
      }

      if ((0, _lodash.includes)(c, 'is_po_c')) {
        cflags.push(['is_po_c', iconPoY, 'Palm oil major consumer brand']);
      }
      if ((0, _lodash.includes)(c, 'is_pp_c')) {
        cflags.push(['is_pp_c', iconPpY, 'Paper/pulp major consumer brand']);
      }
      if ((0, _lodash.includes)(c, 'is_rb_c')) {
        cflags.push(['is_rb_c', iconRbY, 'Rubber major consumer brand']);
      }
      if ((0, _lodash.includes)(c, 'is_tb_c')) {
        cflags.push(['is_tb_c', iconTbY, 'Timber major consumer brand']);
      }
      if ((0, _lodash.includes)(c, 'is_bf_c')) {
        cflags.push(['is_bf_c', iconBfY, 'Cattle major consumer brand']);
      }
      if ((0, _lodash.includes)(c, 'is_sy_c')) {
        cflags.push(['is_sy_c', iconSyY, 'Soy major consumer brand']);
      }

      var is_p = pflags.length > 0;
      var is_c = cflags.length > 0;

      var links = CompanyLinks.data[this.props.company_id];
      var zsl_spott = links ? links.zsl_spott : '';
      var supply_change = links ? links.supply_change : '';
      var banktrack = links ? links.banktrack : '';
      var rspo = links ? links.rspo : '';
      var forest500 = links ? links.forest500 : '';
      var other_link = links ? links.other_link : '';
      var link_map = [[zsl_spott, 'ZSL SPOTT'], [supply_change, 'Supply Change'], [banktrack, 'BankTrack'], [rspo, 'RSPO'], [forest500, 'Forest500'], [other_link, 'Other']];

      var has_links = zsl_spott || supply_change || banktrack || rspo || forest500 || other_link;

      var hasLogo = false;
      var companyLogo = null;
      try {
        companyLogo = require('../../../static/images/companies/' + this.props.company_id + '.png');
        hasLogo = true;
      } catch (e) {
        console.log('');
      }

      //
      return _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement(
          'span',
          { onClick: this.openModal, styleName: 'modal-opener' },
          this.props.children,
          _react2.default.createElement(_.LinkIcon, { faclass: 'fa-info-circle' })
        ),
        _react2.default.createElement(
          _reactModal2.default,
          {
            isOpen: this.state.modalOpen,
            onRequestClose: this.closeModal,
            contentLabel: 'This fund is managed by',
            style: {
              overlay: {
                backgroundColor: 'rgba(0, 0, 0, 0.75)'
              },
              content: {
                position: 'absolute',
                left: 0,
                right: 0,
                marginLeft: 'auto',
                marginRight: 'auto',
                borderRadius: 0,
                width: '900px',
                maxWidth: '90%',
                top: '50%',
                border: '0px',
                background: '#fff',
                overflow: 'visible',
                bottom: 'auto',
                WebkitOverflowScrolling: 'touch',
                outline: 'none',
                transform: 'translateY(-50%)',
                padding: 0
              }
            } },
          _react2.default.createElement(
            'div',
            { styleName: 'family-modal-wrap' },
            _react2.default.createElement(
              'div',
              { styleName: 'family-modal' },
              _react2.default.createElement(
                'div',
                { styleName: 'family-modal-header-wrap' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'family-modal-header' },
                  shortName
                ),
                hasLogo ? _react2.default.createElement('img', {
                  styleName: 'company-logo-img',
                  src: companyLogo,
                  alt: shortName
                }) : null
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'family-modal-p' },
                profile
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'modal-icons-wrap' },
                is_p ? _react2.default.createElement(
                  'div',
                  { styleName: 'icons-wrap' },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'sector-headline-wrap' },
                    _react2.default.createElement('img', {
                      styleName: 'sector-icon',
                      src: producersIcon,
                      alt: 'Deforestation-risk agricultural commodity producer/trader'
                    }),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'sector-headline-p' },
                      'Agricultural commodity producer/trader'
                    )
                  ),
                  this.renderFlags(pflags)
                ) : null,
                is_c ? _react2.default.createElement(
                  'div',
                  { styleName: 'icons-wrap' },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'sector-headline-wrap' },
                    _react2.default.createElement('img', {
                      styleName: 'sector-icon',
                      src: consumersIcon,
                      alt: 'Major consumer brands'
                    }),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'sector-headline-c' },
                      'Major consumer brand'
                    )
                  ),
                  this.renderFlags(cflags)
                ) : null
              ),
              /* if the company has any research links...  */
              has_links ? _react2.default.createElement(
                'div',
                { styleName: 'links-box' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'links-headline' },
                  'Source information:'
                ),
                /* ..display links for the company  */
                link_map.map(function (e, i) {
                  var has_link = e[0].length;
                  if (has_link) {
                    return _react2.default.createElement(
                      'div',
                      { key: i, styleName: 'research-link-div' },
                      _react2.default.createElement(
                        _.Link,
                        {
                          to: e[0],
                          title: e[1],
                          xstrong: true
                        },
                        e[1],
                        _react2.default.createElement(_.LinkIcon, null)
                      )
                    );
                  } else {
                    return null;
                  }
                })
              ) : null
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'family-modal-close-wrap', onClick: this.closeModal },
              _react2.default.createElement('div', { styleName: 'family-modal-close', className: 'fa fa-times' })
            )
          )
        )
      );
    }
  }]);
  return CompanyProfileModal;
}(_react.Component), _class2.propTypes = {
  company_id: _react.PropTypes.string.isRequired
}, _temp)) || _class);
exports.default = CompanyProfileModal;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/CompanyProfileModal/CompanyProfileModal.js
// module id = 1316
// module chunks = 0